/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */

export async function loadDepartmentDetails(searchFilter) {
  return await api
    .post(`/protected/getdept`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadDesignationDetails(searchFilter) {
  return await api
    .post(`/protected/getallDesign`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadRoleDetails(searchFilter) {
  return await api
    .post(`/protected/getallrole`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadLoginShiftDetails(searchFilter) {
  return await api
    .post(`/protected/getallshift`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadLopSettingDetails(searchFilter) {
  return await api
    .post(`/protected/getlopsetting`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadMasterHolidayDetails(searchFilter) {
  return await api
    .post(`/protected/getholiday`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
    loadDepartmentDetails,
    loadDesignationDetails,
    loadRoleDetails,
    loadLoginShiftDetails,
    loadLopSettingDetails,
    loadMasterHolidayDetails
};

export default remotes;